import { Button, Grid, Box, IconButton, Stack, Typography, Radio, RadioGroup, FormControlLabel } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const IndoorBillingManagementReport = ({ onClose, onAdd, reportId }) => {
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        doctor: Yup.string().required('Please select Doctor'),
        service: Yup.string().required('Please select Service')
      })
    ),
    mode: 'all'
  });

  const { handleSubmit, setValue, watch } = methods;
  const typeWatch = watch('type');
  console.log(typeWatch, 'HELLLO TYPEWATCH');
  useEffect(() => {
    if (typeWatch === 'detail' || typeWatch === 'detail1' || 
        ((typeWatch === 'summary' || typeWatch === 'summary1' || typeWatch === "summary2") && reportId)) {
      
      const route = typeWatch === 'detail' 
        ? '/detail' 
        : typeWatch === 'detail1' 
        ? '/detail1' // Added this condition for 'detail1'
        : typeWatch === 'summary1' 
        ? '/summary1' 
        : typeWatch === 'summary2' 
        ? '/summary2' 
        : '/summary'; // Default to '/summary' if none of the conditions match
  
      window.open(`/print${pathname}${route}?refId=${reportId}`, '_blank');
    }
  }, [typeWatch, pathname, reportId, watch]);
  

  const formSubmitHandler = (formValues) => {
    formValues.gst_per = +formValues.gst_per;
    formValues.disc_per = +formValues.disc_per;
    formValues.quantity = +formValues.quantity;
  };

  return (
    <Stack
      spacing={3}
      sx={{
        height: '100%',
        padding: 3,
        backgroundColor: '#ffffff',
        borderRadius: 3,
        boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '700px',
        margin: 'auto'
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" paddingY={2} paddingX={3}>
        <Typography variant="h5" fontWeight="bold" sx={{ color: '#333' }}>
          Print Report
        </Typography>
        <IconButton onClick={onClose} color="error">
          <CloseIcon fontSize="large" />
        </IconButton>
      </Stack>

      <FormProvider methods={methods} onSubmit={handleSubmit(formSubmitHandler)}>
        <Grid container spacing={2}>
          {[
            { label: 'Summary', value: 'summary' },
            { label: 'Summary1', value: 'summary1' },
            { label: 'Summary2', value: 'summary2' },
            { label: 'Detail', value: 'detail' },
            { label: 'Detail1', value: 'detail1' }
          ].map((item) => (
            <Grid item xs={12} sm={6} key={item.value}>
              <Box
                sx={{
                  backgroundColor: '#f5f5f5',
                  borderRadius: 1.5,
                  padding: 3,
                  border: '1px solid #ddd',
                  textAlign: 'center',
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    backgroundColor: '#e8e8e8',
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
                  }
                }}
              >
                <RadioGroup value={typeWatch} onChange={(e) => setValue('type', e.target.value)} row>
                  <FormControlLabel
                    value={item.value}
                    control={<Radio color="primary" />}
                    label={
                      <Typography variant="body1" sx={{ color: '#444' }}>
                        {item.label}
                      </Typography>
                    }
                    sx={{
                      marginX: 2,
                      '& .MuiTypography-root': {
                        fontWeight: 'medium',
                        color: '#444'
                      }
                    }}
                  />
                </RadioGroup>
              </Box>
            </Grid>
          ))}
        </Grid>
      </FormProvider>
    </Stack>
  );
};
